import { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { Card, CardContent } from './ui/card';
import { Plus, X, Check } from 'lucide-react';
import { cleanMoney } from './AddMilestoneDialog';

interface InlineMilestoneFormProps {
  onAdd: (milestone: {
    name: string;
    percentage: number;
    description: string;
    
  }) => boolean | void;
  totalContractValue: number;
  isOpen:any;
  setIsOpen:any;
  name:any;
  setName:any;
  percentage:any;
  setPercentage:any;
  description:any;
  setDescription:any;
  milestoneId:any;
  isEscrowProject:any;
  isEditDisable:any
  maxPercentage?: number;
  onCancel?: () => void;
}

export function InlineMilestoneForm({ onAdd,isEditDisable,isEscrowProject,isOpen,milestoneId,setIsOpen,name,setName,percentage,setPercentage,description,setDescription, totalContractValue, maxPercentage = 100, onCancel }: InlineMilestoneFormProps) {
 

  const handleSubmit = () => {
    if (name && percentage) {
      const wasAccepted = onAdd({
        name,
        percentage: parseFloat(percentage),
        description,
      });
      if (wasAccepted === false) return;
      setName('');
      setPercentage('');
      setDescription('');
      setIsOpen(false);
    }
  };

  const handleCancel = () => {
    setName('');
    setPercentage('');
    setDescription('');
    setIsOpen(false);
    onCancel?.();
  };

  const baseAmount = cleanMoney(totalContractValue)
  const calculatedAmount =
    baseAmount * (parseFloat(percentage) || 0) / 100;
  if (!isOpen ) {
    if(!isEscrowProject){
      return (
        <Button
          onClick={() => setIsOpen(true)}
          size="sm"
          className="w-full shadow-sm h-9 border-0"
          style={{ backgroundColor: '#1f57d6', color: 'white' }}
        >
          <Plus className="mr-1.5 h-4 w-4" />
          Add New Milestone
        </Button>
      );
    }else{
      return <></>
    }
  
  }

  return (
    <Card className="border bg-white" style={{ borderColor: '#e5e7eb' }}>
      <CardContent className="pt-4 pb-4">
        <div className="space-y-3">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-sm" style={{ color: '#1f57d6' }}>
              {milestoneId?"Update milestone":"Add New Milestone"}
            </h3>
            <Button variant="ghost" size="sm" onClick={handleCancel} className="h-7 border-0 w-7 p-0">
              <X className="h-3.5 w-3.5" />
            </Button>
          </div>

          <div>
            <Label htmlFor="milestone-name" className="text-xs">Milestone Name *</Label>
            <Input
              id="milestone-name"
              readOnly={isEditDisable}
              placeholder="e.g., Foundation Complete"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="mt-1 border text-sm h-9"
              style={{ borderColor: '#d1d5db' }}
            />
          </div>

          <div>
            <Label htmlFor="percentage" className="text-xs">Percentage of Contract *</Label>
            <div className="relative mt-1">
              <Input
                id="percentage"
                type="number"
                min="0"
                max={maxPercentage}
                readOnly={isEditDisable||isEscrowProject}
                step="0.1"
                placeholder="0"
                value={percentage}
                onChange={(e) => setPercentage(e.target.value)}
                className="pr-8 border text-sm h-9"
                style={{ borderColor: '#d1d5db' }}
              />
              <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs" style={{ color: '#6b7280' }}>%</span>
            </div>
            {percentage && (
              <p className="text-xs mt-1" style={{ color: '#1f57d6' }}>
                Amount: ${calculatedAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </p>
            )}
            <p className="text-xs mt-1" style={{ color: '#6b7280' }}>
              Up to {maxPercentage}% available for this milestone.
            </p>
          </div>

          <div>
            <Label htmlFor="description" className="text-xs">Description (Optional)</Label>
            <Textarea
              id="description"
              placeholder="Describe the work included in this milestone..."
              value={description}
              readOnly={isEditDisable}
              onChange={(e) => setDescription(e.target.value)}
              className="mt-1 border text-xs"
              style={{ borderColor: '#d1d5db' }}
              rows={2}
            />
          </div>

          <div className="flex gap-2 pt-1">
            <Button
              onClick={handleSubmit}
              disabled={!name || !percentage ||isEditDisable}
              className="flex-1 border-0 h-8 text-xs"
              style={{ backgroundColor: '#1f57d6', color: 'white' }}
            >
              <Check className="mr-1.5 h-3.5 w-3.5" />
             {milestoneId?"Update":"Add"} Milestone
            </Button>
            <Button variant="outline" onClick={handleCancel} className="h-8 text-xs">
              Cancel
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
